import { render } from "./ViewQcm.vue?vue&type=template&id=70502890&scoped=true"
import script from "./ViewQcm.vue?vue&type=script&lang=js"
export * from "./ViewQcm.vue?vue&type=script&lang=js"

import "./ViewQcm.vue?vue&type=style&index=0&id=70502890&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70502890"]])

export default __exports__